import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Modal,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { GET_USER_CONTACT_STATUS_NAME, INVITEFRIENDSBYEMAIL } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { English } from "../../constant/EnglishFallback";
import { IoAddCircleOutline, IoSearchOutline } from "react-icons/io5";
import { resetChatState, setfrom, setOpen } from "../../redux/actions/actions";
import { createChatGroupAndNavigate, navigateToChatPage } from "../../common/Helper";
import NewChatModal from "../chat/NewChatModal";

const MemberList = ({
  isOpen,
  onClose,
  isLoading,
  members,
  handleConnectClick,
  handleMessageClick,
  profileMemberList,
  showBtnLoader,
  setShowbtnLoader,
  from,
  setCompanyData,
  setProductData,
  setTradeData,
  setProjectData,
  selectedChat,
  // setOpen,
  // setfrom,
  openNew,
  getData,
  title,
  imageUrl
}) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [indexNo, setIndexNo] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    TEXT_CONNECT_REQUEST = English?.MemberList?.TEXT_CONNECT_REQUEST,
    TEXT_REQUESTED_CONNECT_WITH_YOU = English?.MemberList?.TEXT_REQUESTED_CONNECT_WITH_YOU,
    TEXT_MEMBERS = English?.MemberList?.TEXT_MEMBERS,
    BUTTON_CONNECT = English?.MemberList?.BUTTON_CONNECT,
    TEXT_MESSAGES = English?.MemberList?.TEXT_MESSAGES,
    TEXT_REQUEST_SEND = English?.MemberList?.TEXT_REQUEST_SEND,
    TEXT_WORKED_ON = English?.MemberList?.TEXT_WORKED_ON,
    TEXT_ME = English?.MemberList?.TEXT_ME,
    TEXT_NO_DATA = English?.MemberList?.TEXT_NO_DATA
  } = multiLanguageData?.MemberList || {};

  const loaderBtn = () => {
    return (
      <>
        <Button disabled={true} color="primary" variant="contained" style={{ width: "100px" }}>
          <CircularProgress size={24} />
        </Button>
      </>
    );
  };

  const onMessageClick = (member) => {
    if (from === "profile") {
      handleMessageClick(member);
    } else if (from === "product-profile") {
      navigateToChat(member);
    } else {
      navigateTochat(member);
    }
  };

  const navigateTochat = async (id) => {
    const targetUserId = id?.contactId || id?.userId;
    createChatGroupAndNavigate(targetUserId, loginData, dispatch, navigate);
    onClose();
  };
  const navigateToChat = (item) => {
    const getUrl = window.location.pathname.split("/").pop();
    navigateToChatPage(navigate, dispatch, from, title, imageUrl, item?.chatGroupId, getUrl);
  };

  const onConnectclick = (member, param) => {
    if (from === "profile" || from === "chatMemberes") {
      handleConnectClick(member, param);
    } else {
      handleAddContact(member, param);
    }
  };

  const handleAddContact = async (data, param) => {
    try {
      setShowbtnLoader(true);
      let obj = {
        UserId: Number(loginData?.userInformation?.UserId),
        FriendsEmails: data?.contactEmail || data?.userEmail,
        Notification: {
          ActionUrl: `${import.meta.env.REACT_APP_CONTACTPROFILE}${Number(
            loginData?.userInformation?.UserId
          )}`,
          title: TEXT_CONNECT_REQUEST,
          Body: TEXT_REQUESTED_CONNECT_WITH_YOU
        }
      };
      const response = await Postrequestcall(INVITEFRIENDSBYEMAIL, obj, loginData?.accessToken);
      setShowbtnLoader(false);
      if (response?.data?.data === "Connect Request Send") {
        if (param === "Member-Modal") {
          updateMembersData(data?.userId, "Request Sent");
        } else {
          userContactStatusName(data?.userId);
        }
      }
    } catch (error) {
      console.log("handleAddContact-> Error When Inviting Friend By Email: ", error);
      setShowbtnLoader(false);
    }
  };

  const updateMembersData = (userId, status) => {
    const updatedMembers = members.map((item) =>
      item.userId === userId ? { ...item, contactStatus: status } : item
    );

    switch (from) {
      case "project-profile":
        setProjectData((prevData) => ({
          ...prevData,
          memberList: updatedMembers
        }));
        break;
      case "trade-profile":
        setTradeData((prevData) => ({
          ...prevData,
          memberList: updatedMembers
        }));
        break;
      case "company-profile":
        setCompanyData((prevData) => ({
          ...prevData,
          memberList: updatedMembers
        }));
        break;
      case "product-profile":
        setProductData((prevData) => ({
          ...prevData,
          memberList: updatedMembers
        }));
        break;
      default:
        // Optionally handle unknown "from" values
        break;
    }
  };

  async function userContactStatusName(contactId) {
    ///setProfileLoading(true);
    const contactStatusRes = await Getrequestcall(
      `${GET_USER_CONTACT_STATUS_NAME}/${loginData?.userInformation?.UserId}/${contactId}`,
      loginData?.accessToken
    );
    const contactStatus = contactStatusRes?.data?.data;
    // setContactStatusName(contactStatus);
  }

  return (
    <>
      {" "}
      <Modal
        open={isOpen ?? false}
        onClose={() => {
          setIndexNo(null);
          onClose();
        }}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6" sx={{ ml: 1 }}>
              {TEXT_MEMBERS}
            </Typography>
            <Box sx={{ display: "flex", gap: "5px" }}>
              <Stack>
                {from === "chatMemberes" ? (
                  <IconButton
                    color="primary"
                    aria-label="create new chat"
                    onClick={() => {
                      // setOpen(true);
                      dispatch(setOpen(true));

                      // setfrom(from);
                      dispatch(setfrom(from));

                      dispatch(resetChatState());
                    }}>
                    <IoAddCircleOutline size={24} />
                  </IconButton>
                ) : (
                  <></>
                )}
              </Stack>
              <Stack>
                <IconButton
                  onClick={() => {
                    setIndexNo(null);
                    onClose();
                  }}>
                  <CloseIcon />
                </IconButton>
              </Stack>
            </Box>
          </Box>
          <Box
            sx={{ height: "500px", padding: "0px 10px", overflow: "auto", scrollbarWidth: "none" }}>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  height: 200
                }}>
                <h3>
                  <Loader />
                </h3>
              </div>
            ) : (
              <List disablePadding>
                {members?.length != 0 ? (
                  <>
                    {members?.map((member, index) => {
                      return (
                        <Card
                          key={index.toString()}
                          className="pagelist-content"
                          style={{ marginBottom: "10px" }}>
                          <ListItem
                            sx={{ m: 0 }}
                            key={index.toString()}
                            secondaryAction={
                              <div style={{ display: "flex" }}>
                                {member.contactStatus == "No" ? (
                                  showBtnLoader && index === indexNo ? (
                                    loaderBtn()
                                  ) : (
                                    <Button
                                      color="primary"
                                      variant="contained"
                                      onClick={() => {
                                        setIndexNo(index);
                                        onConnectclick(member, "Member-Modal");
                                      }}>
                                      {BUTTON_CONNECT}
                                    </Button>
                                  )
                                ) : member.contactStatus == "me" ||
                                  member.contactStatus == "Yes" ? (
                                  showBtnLoader && index === indexNo ? (
                                    loaderBtn()
                                  ) : (
                                    <Button
                                      color="primary"
                                      variant="outlined"
                                      onClick={() => {
                                        setIndexNo(index);
                                        onMessageClick(member);
                                      }}>
                                      {TEXT_MESSAGES}
                                    </Button>
                                  )
                                ) : member.contactStatus == "Request Sent" ||
                                  member.contactStatus === "Awaiting response" ? (
                                  <Button disabled color="primary" variant="text">
                                    {TEXT_REQUEST_SEND}
                                  </Button>
                                ) : null}
                              </div>
                            }
                            disablePadding>
                            <ListItemButton
                              sx={{ display: "flex", flexDirection: "row" }}
                              onClick={() => {
                                setIndexNo(null);
                                onClose(1);

                                navigate(`/${member?.contactId || member?.userId}`);
                              }}>
                              <ListItemAvatar>
                                <Avatar
                                  alt="contact-PictureUrl"
                                  src={
                                    profileMemberList ? member.contactPictureUrl : member.pictureUrl
                                  }
                                />
                              </ListItemAvatar>

                              <ListItemText
                                primary={
                                  <Stack>
                                    {profileMemberList ? (
                                      <Typography variant="body1" maxWidth={"280px"} noWrap>
                                        {member.contactName}
                                        <Typography
                                          sx={{
                                            color: "text.secondary",
                                            display: "inline"
                                          }}>
                                          {member.workOnSameSite ? ` | ${TEXT_WORKED_ON}` : null}
                                        </Typography>
                                      </Typography>
                                    ) : (
                                      <Typography variant="body1" maxWidth={"280px"} noWrap>
                                        {member.firstName + " " + member.lastName}
                                        <Typography
                                          sx={{
                                            color: "text.secondary",
                                            display: "inline"
                                          }}>
                                          {member.contactStatus == "me"
                                            ? ` ${TEXT_ME}`
                                            : member.contactStatus != "me" && member?.addToProfile
                                              ? ` | ${TEXT_WORKED_ON}`
                                              : null}
                                        </Typography>
                                      </Typography>
                                    )}
                                  </Stack>
                                }
                                secondary={member.tradeName}
                              />
                            </ListItemButton>
                          </ListItem>
                        </Card>
                      );
                    })}
                  </>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: 200
                    }}>
                    <h3>{TEXT_NO_DATA}</h3>
                  </div>
                )}
              </List>
            )}
            <NewChatModal
              open={openNew}
              from={from}
              getData={getData}
              selectedChat={selectedChat}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default MemberList;
